// Service pages content. Professional building vocabulary only — no invented
// prices, norms, certifications or performance figures.
import {
  RAVALEMENT_IMG,
  ITE_IMG,
  TCE_IMG,
  ETANCHEITE_IMG,
  COUVERTURE_IMG,
} from './serviceImages';

export const SERVICES = [
  {
    slug: 'ravalement-facade-paris',
    path: '/ravalement-facade-paris',
    nav: 'Ravalement de façade',
    badge: 'Ravalement de façade',
    image: RAVALEMENT_IMG,
    metaTitle: 'Ravalement de façade à Paris & Île-de-France | VIREO',
    metaDescription:
      "Entreprise de ravalement de façade à Paris et en Île-de-France : nettoyage, réparation, enduit à la chaux, façade en pierre, immeubles et copropriétés. Devis gratuit.",
    h1: 'Ravalement de façade à Paris et en Île-de-France',
    primaryKeyword: 'ravalement façade Paris',
    secondaryKeywords: [
      'entreprise ravalement façade',
      'façadier Paris',
      'ravalement copropriété',
      'ravalement façade pierre',
      'enduit façade à la chaux',
    ],
    heroIntro:
      "VIREO réalise le ravalement de façade des immeubles, copropriétés et maisons à Paris et en Île-de-France : diagnostic, nettoyage, réparation des supports et finitions adaptées au bâti ancien comme récent.",
    sections: [
      {
        h2: 'Les travaux de ravalement que nous réalisons',
        body: "Le ravalement remet la façade en état et la protège durablement. Nous intervenons sur les enduits, la pierre de taille, la brique et les façades enduites.",
        items: [
          'Diagnostic de la façade et des pathologies (fissures, décollements, salissures)',
          'Nettoyage adapté (gommage, hydrogommage, nettoyage basse pression)',
          'Réparation des fissures, reprise des enduits et des pierres',
          'Application d’enduits, peintures de façade et traitements hydrofuges',
          'Traitement des points singuliers : corniches, appuis, modénatures',
        ],
      },
      {
        h2: 'Méthodes et matériaux',
        body: "Le choix du procédé dépend du support et de son état. Sur bâti ancien, nous privilégions les enduits à la chaux, perméables à la vapeur d’eau, pour respecter la façade. Sur support moderne, nous utilisons des systèmes d’enduit organique ou minéral et des peintures façade.",
        items: [
          'Enduits à la chaux (aérienne ou hydraulique) pour le bâti ancien',
          'Enduits minéraux et organiques pour les supports récents',
          'Traitements hydrofuges et anti-mousses',
          'Reprise de modénatures et éléments décoratifs',
        ],
      },
      {
        h2: 'Contraintes techniques',
        body: "Un ravalement en ville implique des contraintes à anticiper : accès et installation d’échafaudage, protection des accès et de la voirie, gestion des copropriétés et, dans certains secteurs, règles d’urbanisme spécifiques. Nous préparons le chantier en conséquence.",
        items: [
          'Échafaudage, protection des accès et sécurité du chantier',
          'Coordination en copropriété (AG, syndic, planning)',
          'Respect des règles d’urbanisme et des prescriptions locales',
          'Gestion des mitoyennetés et de la voirie',
        ],
      },
      {
        h2: 'Ce qui influence le prix',
        body: "Chaque ravalement est chiffré après visite. Plusieurs facteurs font varier le coût d’un chantier à l’autre.",
        items: [
          'Surface et hauteur de la façade',
          'État du support et ampleur des réparations',
          'Type de finition (enduit, peinture, pierre)',
          'Accès et moyens d’échafaudage nécessaires',
          'Complexité des modénatures et points singuliers',
        ],
      },
      {
        h2: 'Types de bâtiments concernés',
        body: "Nous ravalons aussi bien les immeubles de rapport et copropriétés que les maisons individuelles et les bâtiments tertiaires.",
        items: [
          'Immeubles haussmanniens et bâti ancien',
          'Copropriétés et immeubles collectifs',
          'Maisons individuelles et pavillons',
          'Locaux professionnels et tertiaires',
        ],
      },
    ],
    faq: [
      {
        q: 'Le ravalement de façade est-il obligatoire ?',
        a: "Dans certaines communes, dont Paris, le ravalement peut être rendu obligatoire par arrêté à une périodicité définie. Nous vous aidons à faire le point sur votre situation lors de la visite.",
      },
      {
        q: 'Intervenez-vous pour les copropriétés ?',
        a: "Oui. Nous répondons aux consultations de syndics et accompagnons les copropriétés, du chiffrage au suivi de chantier, en coordination avec le conseil syndical.",
      },
      {
        q: 'Quelle finition choisir pour une façade ancienne ?',
        a: "Sur un bâti ancien, un enduit à la chaux est souvent recommandé car il laisse respirer les murs. Le choix final dépend du support, de l’exposition et des prescriptions locales.",
      },
      {
        q: 'Comment obtenir un devis de ravalement ?',
        a: "Décrivez votre projet via le formulaire et joignez des photos de la façade. Nous revenons vers vous pour une visite et un devis gratuit.",
      },
    ],
    related: ['isolation-thermique-exterieure-ite', 'etancheite-toiture-terrasse', 'couverture-toiture'],
  },

  {
    slug: 'isolation-thermique-exterieure-ite',
    path: '/isolation-thermique-exterieure-ite',
    nav: 'Isolation extérieure (ITE)',
    badge: 'Isolation thermique par l’extérieur',
    image: ITE_IMG,
    metaTitle: 'Isolation thermique extérieure (ITE) à Paris & Île-de-France | VIREO',
    metaDescription:
      "Entreprise d’isolation thermique par l’extérieur (ITE) en Île-de-France : isolation extérieure de maison et d’immeuble, finitions enduit, isolants biosourcés. Devis gratuit.",
    h1: 'Isolation thermique par l’extérieur (ITE) en Île-de-France',
    primaryKeyword: 'isolation thermique extérieure Paris',
    secondaryKeywords: [
      'entreprise ITE Île-de-France',
      'isolation extérieure maison',
      'prix isolation extérieure',
      'ITE enduit',
      'isolation biosourcée',
    ],
    heroIntro:
      "L’ITE enveloppe le bâtiment d’un manteau isolant et traite les ponts thermiques sans réduire la surface habitable. VIREO conçoit et pose des systèmes d’isolation extérieure, y compris en isolants biosourcés, à Paris et en Île-de-France.",
    sections: [
      {
        h2: 'En quoi consiste l’ITE',
        body: "L’isolation par l’extérieur consiste à poser un isolant sur les murs extérieurs, recouvert d’une finition (enduit ou bardage). Elle améliore le confort et peut être couplée à un ravalement.",
        items: [
          'Pose d’isolant sur l’ensemble de l’enveloppe',
          'Traitement des ponts thermiques',
          'Finition enduit mince ou enduit hydraulique',
          'Possibilité de bardage selon le projet',
          'Couplage possible avec un ravalement de façade',
        ],
      },
      {
        h2: 'Méthodes et matériaux',
        body: "Nous adaptons l’isolant et le système de finition au bâtiment et à vos priorités, y compris des solutions biosourcées comme la fibre de bois ou le liège, dans la continuité de notre positionnement écologique.",
        items: [
          'Systèmes sous enduit (isolant + sous-enduit armé + finition)',
          'Isolants biosourcés : fibre de bois, liège',
          'Isolants conventionnels selon contexte',
          'Traitement soigné des points singuliers (tableaux, appuis, acrotères)',
        ],
      },
      {
        h2: 'Contraintes techniques',
        body: "L’ITE modifie l’aspect extérieur et l’épaisseur des murs : elle demande une étude des interfaces et, souvent, des démarches d’urbanisme. En secteur contraint, l’avis des autorités compétentes peut être requis.",
        items: [
          'Gestion des débords de toiture et des menuiseries',
          'Démarches d’urbanisme (déclaration préalable selon les cas)',
          'Contraintes en secteur patrimonial',
          'Coordination en copropriété',
        ],
      },
      {
        h2: 'Ce qui influence le prix',
        body: "Le coût d’une ITE se chiffre après étude. Plusieurs paramètres entrent en jeu.",
        items: [
          'Surface de façade et complexité géométrique',
          'Type et épaisseur de l’isolant',
          'Système de finition (enduit, bardage)',
          'Reprises préalables du support',
          'Accès et échafaudage',
        ],
      },
      {
        h2: 'Types de bâtiments concernés',
        body: "L’ITE s’applique aux maisons comme aux immeubles, en rénovation.",
        items: [
          'Maisons individuelles et pavillons',
          'Immeubles collectifs et copropriétés',
          'Bâtiments tertiaires',
        ],
      },
    ],
    faq: [
      {
        q: 'L’ITE réduit-elle la surface habitable ?',
        a: "Non. Contrairement à l’isolation intérieure, l’ITE est posée sur les murs extérieurs : elle ne réduit pas la surface intérieure.",
      },
      {
        q: 'Peut-on faire l’ITE et le ravalement en même temps ?',
        a: "Oui, c’est fréquent et souvent pertinent : la finition de l’ITE joue le rôle de ravalement, ce qui mutualise l’échafaudage et le chantier.",
      },
      {
        q: 'Proposez-vous des isolants biosourcés ?',
        a: "Oui. Nous proposons notamment la fibre de bois et le liège, dans la continuité de notre spécialité écologique, sans nous limiter aux seuls matériaux naturels.",
      },
      {
        q: 'Faut-il une autorisation d’urbanisme pour une ITE ?',
        a: "Une ITE modifie l’aspect extérieur : une déclaration préalable est souvent nécessaire et des règles particulières s’appliquent en secteur protégé. Nous vous orientons lors de l’étude.",
      },
    ],
    related: ['ravalement-facade-paris', 'renovation-energetique', 'renovation-tous-corps-etat'],
  },

  {
    slug: 'renovation-tous-corps-etat',
    path: '/renovation-tous-corps-etat',
    nav: 'Rénovation tous corps d’état',
    badge: 'Rénovation TCE',
    image: TCE_IMG,
    metaTitle: 'Rénovation tous corps d’état (TCE) à Paris | VIREO',
    metaDescription:
      "Entreprise de rénovation tous corps d’état à Paris et en Île-de-France : rénovation d’appartement et de maison, coordination de l’ensemble des lots. Devis gratuit.",
    h1: 'Rénovation tous corps d’état (TCE) à Paris',
    primaryKeyword: 'entreprise rénovation tous corps d’état',
    secondaryKeywords: [
      'rénovation appartement Paris',
      'rénovation TCE',
      'rénovation maison Île-de-France',
      'entreprise générale de rénovation',
    ],
    heroIntro:
      "En tant qu’entreprise générale, VIREO coordonne l’ensemble des corps d’état d’un chantier de rénovation : un seul interlocuteur, du chiffrage à la livraison, à Paris et en Île-de-France.",
    sections: [
      {
        h2: 'Une rénovation coordonnée de A à Z',
        body: "La rénovation tous corps d’état réunit sous une même maîtrise les différents métiers d’un chantier. Nous planifions et pilotons les interventions pour un résultat cohérent.",
        items: [
          'Démolition et préparation',
          'Maçonnerie, cloisons et plâtrerie',
          'Électricité et plomberie',
          'Menuiseries intérieures et extérieures',
          'Revêtements de sols et murs, peinture, finitions',
        ],
      },
      {
        h2: 'Méthodes et organisation',
        body: "Nous établissons un planning clair, coordonnons les intervenants et assurons le suivi du chantier avec un interlocuteur dédié. L’objectif : limiter les aléas et tenir les délais.",
        items: [
          'Étude du projet et chiffrage détaillé par lots',
          'Planning et coordination des corps d’état',
          'Suivi de chantier et points réguliers',
          'Réception et levée des réserves',
        ],
      },
      {
        h2: 'Contraintes techniques',
        body: "En rénovation d’appartement, les contraintes d’immeuble sont déterminantes : horaires de chantier, protection des parties communes, règlement de copropriété et évacuation des gravats.",
        items: [
          'Respect du règlement de copropriété et des horaires',
          'Protection des parties communes et des accès',
          'Contraintes techniques du bâti existant',
          'Gestion des évacuations et approvisionnements',
        ],
      },
      {
        h2: 'Ce qui influence le prix',
        body: "Le budget d’une rénovation TCE dépend de l’ampleur du projet et de l’état de l’existant. Chaque chantier est chiffré après visite.",
        items: [
          'Surface et nombre de pièces',
          'Nature des travaux (rafraîchissement ou rénovation lourde)',
          'Niveau de finition recherché',
          'Modifications de distribution et de réseaux',
          'État de l’existant',
        ],
      },
      {
        h2: 'Types de projets concernés',
        body: "Nous intervenons sur des projets variés, du rafraîchissement à la rénovation complète.",
        items: [
          'Rénovation complète d’appartement',
          'Rénovation de maison individuelle',
          'Réagencement et optimisation d’espaces',
          'Locaux professionnels',
        ],
      },
    ],
    faq: [
      {
        q: 'Qu’est-ce qu’une rénovation « tous corps d’état » ?',
        a: "C’est une rénovation où une seule entreprise coordonne l’ensemble des métiers (maçonnerie, électricité, plomberie, menuiseries, finitions). Vous avez un interlocuteur unique.",
      },
      {
        q: 'Gérez-vous les contraintes de copropriété ?',
        a: "Oui. Nous intégrons le règlement de copropriété, les horaires autorisés et la protection des parties communes dès la préparation du chantier.",
      },
      {
        q: 'Pouvez-vous rénover un appartement occupé ?',
        a: "Selon l’ampleur des travaux, une rénovation en site occupé est parfois possible par phases. Nous l’évaluons lors de la visite.",
      },
      {
        q: 'Comment se déroule le chiffrage ?',
        a: "Après une visite, nous établissons un devis détaillé par lots afin que vous visualisiez clairement le périmètre et le budget.",
      },
    ],
    related: ['renovation-energetique', 'ravalement-facade-paris', 'etancheite-toiture-terrasse'],
  },

  {
    slug: 'etancheite-toiture-terrasse',
    path: '/etancheite-toiture-terrasse',
    nav: 'Étanchéité toitures & terrasses',
    badge: 'Étanchéité',
    image: ETANCHEITE_IMG,
    metaTitle: 'Étanchéité de toiture et terrasse en Île-de-France | VIREO',
    metaDescription:
      "Entreprise d’étanchéité de toiture-terrasse à Paris et en Île-de-France : réfection d’étanchéité, membrane bitume ou EPDM, traitement des infiltrations. Devis gratuit.",
    h1: 'Étanchéité de toitures et terrasses',
    primaryKeyword: 'entreprise étanchéité toiture',
    secondaryKeywords: [
      'étanchéité terrasse',
      'réfection étanchéité toiture-terrasse',
      'infiltration toiture terrasse',
      'membrane EPDM',
    ],
    heroIntro:
      "VIREO traite l’étanchéité des toitures-terrasses et toitures plates : diagnostic des infiltrations, réfection de l’étanchéité et traitement des points singuliers, à Paris et en Île-de-France.",
    sections: [
      {
        h2: 'Nos interventions en étanchéité',
        body: "Une toiture-terrasse protège le bâtiment contre l’eau : une étanchéité défaillante provoque infiltrations et désordres. Nous diagnostiquons et rénovons l’étanchéité.",
        items: [
          'Diagnostic des infiltrations et de l’état du complexe',
          'Réfection complète de l’étanchéité',
          'Traitement des relevés, évacuations et points singuliers',
          'Mise en place ou reprise de protection (gravillons, dalles)',
        ],
      },
      {
        h2: 'Méthodes et matériaux',
        body: "Le complexe d’étanchéité est choisi selon la configuration de la toiture et son usage (accessible ou non, végétalisée, technique).",
        items: [
          'Membranes bitumineuses soudées',
          'Membranes synthétiques (type EPDM)',
          'Traitement des relevés et des évacuations d’eaux pluviales',
          'Isolation sous étanchéité selon le projet',
        ],
      },
      {
        h2: 'Contraintes techniques',
        body: "L’étanchéité exige une mise en œuvre rigoureuse : la moindre reprise mal traitée peut laisser passer l’eau. L’accès en hauteur et la gestion des évacuations sont des points clés.",
        items: [
          'Préparation et séchage du support',
          'Traitement soigné des points singuliers',
          'Accès en hauteur et sécurité',
          'Gestion des eaux pluviales',
        ],
      },
      {
        h2: 'Ce qui influence le prix',
        body: "Le coût dépend de la surface, de l’état du support et du complexe retenu. Un diagnostic précède tout chiffrage.",
        items: [
          'Surface de la toiture-terrasse',
          'État du support et dépose éventuelle',
          'Type de complexe d’étanchéité',
          'Isolation associée',
          'Accès et protection',
        ],
      },
      {
        h2: 'Types de bâtiments concernés',
        body: "Nous intervenons sur toitures-terrasses accessibles ou techniques.",
        items: [
          'Immeubles et copropriétés',
          'Maisons à toiture plate',
          'Terrasses accessibles',
          'Locaux tertiaires',
        ],
      },
    ],
    faq: [
      {
        q: 'Comment savoir si mon étanchéité est défaillante ?',
        a: "Des traces d’humidité, des auréoles au plafond ou des infiltrations après la pluie sont des signaux. Un diagnostic permet d’en localiser l’origine.",
      },
      {
        q: 'Faut-il tout refaire en cas d’infiltration ?',
        a: "Pas toujours. Selon l’état du complexe, une réparation localisée peut suffire ; dans d’autres cas, une réfection complète est préférable. Le diagnostic tranche.",
      },
      {
        q: 'Travaillez-vous sur toitures végétalisées ?',
        a: "Oui, nous adaptons le complexe d’étanchéité à l’usage de la toiture, y compris les configurations végétalisées ou techniques.",
      },
      {
        q: 'Intervenez-vous en urgence sur une fuite ?',
        a: "Décrivez la situation via le formulaire : nous évaluons la priorité et organisons une intervention adaptée.",
      },
    ],
    related: ['couverture-toiture', 'ravalement-facade-paris', 'renovation-tous-corps-etat'],
  },

  {
    slug: 'couverture-toiture',
    path: '/couverture-toiture',
    nav: 'Couverture & toiture',
    badge: 'Couverture',
    image: COUVERTURE_IMG,
    metaTitle: 'Couverture et travaux de toiture à Paris & Île-de-France | VIREO',
    metaDescription:
      "Entreprise de couverture à Paris et en Île-de-France : réfection de toiture, zinguerie, remplacement de fenêtres de toit, traitement des points singuliers. Devis gratuit.",
    h1: 'Couverture et travaux de toiture',
    primaryKeyword: 'entreprise couverture Paris',
    secondaryKeywords: [
      'couvreur Paris',
      'réfection toiture',
      'zinguerie',
      'fenêtre de toit',
      'travaux de toiture Île-de-France',
    ],
    heroIntro:
      "VIREO réalise la couverture et la zinguerie des toitures : réfection, réparation, habillage en zinc et pose de fenêtres de toit, à Paris et en Île-de-France.",
    sections: [
      {
        h2: 'Nos travaux de couverture',
        body: "La couverture et la zinguerie assurent l’étanchéité à l’eau de la toiture. Nous intervenons en réparation ponctuelle comme en réfection.",
        items: [
          'Réfection et réparation de toiture',
          'Zinguerie : noues, chéneaux, souches de cheminée',
          'Pose et remplacement de fenêtres de toit',
          'Traitement des points singuliers et raccords',
        ],
      },
      {
        h2: 'Méthodes et matériaux',
        body: "Le choix des matériaux dépend de la toiture existante et de son environnement : nous travaillons notamment le zinc pour la zinguerie et les raccords.",
        items: [
          'Zinguerie en zinc (souches, solins, habillages)',
          'Remplacement d’éléments de couverture',
          'Raccords d’étanchéité autour des émergences',
          'Pose de fenêtres de toit avec étanchéité associée',
        ],
      },
      {
        h2: 'Contraintes techniques',
        body: "Les travaux en toiture imposent sécurité en hauteur et étanchéité parfaite des raccords. En secteur contraint, l’aspect de la toiture peut être réglementé.",
        items: [
          'Travail en hauteur et sécurité',
          'Étanchéité des raccords et points singuliers',
          'Contraintes d’aspect en secteur patrimonial',
          'Accès et moyens de levage',
        ],
      },
      {
        h2: 'Ce qui influence le prix',
        body: "Chaque toiture est chiffrée après examen. Plusieurs éléments font varier le coût.",
        items: [
          'Surface et pente de la toiture',
          'Nature et état de la couverture',
          'Ampleur de la zinguerie',
          'Accès et sécurité',
          'Points singuliers à traiter',
        ],
      },
      {
        h2: 'Types de bâtiments concernés',
        body: "Nous intervenons sur toitures en pente et leurs ouvrages de zinguerie.",
        items: [
          'Immeubles et copropriétés',
          'Maisons individuelles',
          'Combles aménagés (fenêtres de toit)',
          'Bâtiments anciens',
        ],
      },
    ],
    faq: [
      {
        q: 'Faites-vous la zinguerie ?',
        a: "Oui : souches de cheminée, chéneaux, noues, solins et habillages en zinc font partie de nos interventions de couverture.",
      },
      {
        q: 'Posez-vous des fenêtres de toit ?',
        a: "Oui, nous posons et remplaçons les fenêtres de toit en traitant l’étanchéité périphérique pour éviter toute infiltration.",
      },
      {
        q: 'Réparez-vous une toiture sans tout refaire ?',
        a: "Souvent oui. Une réparation ciblée peut suffire selon l’état général ; dans d’autres cas, une réfection est plus durable. Nous l’évaluons sur place.",
      },
      {
        q: 'Intervenez-vous sur le bâti ancien ?',
        a: "Oui, en tenant compte des matériaux d’origine et, le cas échéant, des contraintes d’aspect en secteur protégé.",
      },
    ],
    related: ['etancheite-toiture-terrasse', 'ravalement-facade-paris', 'renovation-tous-corps-etat'],
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
